export const selectAuthenticated = state => state.auth.authenticated;
export const selectAuthenticatedKey = state => state.auth.key;

export const selectSignUpType = state => state.auth.signupType;
export const selectSignUpRoute = state => state.auth.signupRoute;
export const selectSignUpInvite = state => state.auth.inviteData;
export const selectSignUpUser = state => state.auth.userData;
export const selectSignUpProperty = state => state.auth.propertyData;

export const selectNetworkError = state => state.auth.networkErrorData;
